import { format as fmt } from "date-fns";

export function format(datestring: string, useSec = false) {
  if (!datestring) {
    return "";
  }
  const tmp = new Date(datestring);
  if (useSec) {
    return fmt(tmp, "yyyy/MM/dd HH:mm:ss");
  } else {
    return fmt(tmp, "yyyy/MM/dd HH:mm");
  }
}

export function format2(datestring: string) {
  if (!datestring) {
    return "";
  }
  const tmp = new Date(datestring);
  return fmt(tmp, "yyyy年 MM月");
}

export function format3(date: string | Date) {
  if (!date) {
    return "";
  }
  const tmp = new Date(date);
  return fmt(tmp, "yyyy/MM/dd");
}

export function format4(date: Date) {
  if (!date) {
    return "";
  }
  return fmt(date, "yyyy-MM-dd");
}
